module.exports = __webpack_public_path__ + "img/JAOC_POP_CheddarCheese_round.56e79d58.png";